import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from '@environments/environment';
import * as Sentry from "@sentry/angular";


if (environment.production) {
  enableProdMode();
}

Sentry.init({
  release: 'tac-fe@1.0.0',
  dsn: environment.sentryDsn,
  environment: environment.environmentName,
  integrations: [
    Sentry.feedbackIntegration(),
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      maskAllInputs: false,
      blockAllMedia: false,
    })
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  profilesSampleRate: 1.0,
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => {
    console.error(err);
  });

